import { useTheme } from 'contexts/ThemeContext';
import { useColorMode } from 'styles/theme';
import { MenuButton } from 'styles/theme_styles/button';
import { ThemeType } from 'styles/themes/KCFTheme';

const isAllowed = () =>
    process.env.KCF_ENV === 'stage01' ||
    process.env.KCF_ENV === 'local' ||
    process.env.NODE_ENV === 'development';

export function DarkThemeToggle() {
    const colorMode = useColorMode();
    const isDark = colorMode === ThemeType.dark;
    const themeToggle = useTheme();
    const toggleChanged = () => {
        themeToggle.setColorMode(isDark ? ThemeType.light : ThemeType.dark);
    };

    return (
        <>
            {isAllowed() && (
                <MenuButton onClick={toggleChanged}>{isDark ? '🌚' : '🌞'}</MenuButton>
            )}
        </>
    );
}
